import { useEffect, useState } from "react";
import Switch from "../../../../components/common/Switch";
import Button from "../../../../components/common/button";
// OLD IMPORTS (kept for reference — remove if card grid is final):
// import DataTable from "react-data-table-component";
// import { ICategoryComponentProps, ITableColumn, IVideos } from "../../../../utils/types";
// import { setDragOnlyInStaging } from "../../../../utils/helpers";
import {
  ICategoryComponentProps,
  IVideos,
} from "../../../../utils/types";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DraggableRow from "../../../../components/common/DragRow";
import {  TrashSvg } from "../../../../icons";
import AddOurStortyModal from "./create-our-story";
import OurStoryPreview from "./our-story-preview";
import useGetEligibilityCriteriaQuery from "../../../../hooks/use-get-eligibility-criteria";
import Spinner from "../../../../components/common/Spinner";
import EditOurStory from "../../../../components/common/Activity/edit-our-story";
import { queryClient } from "../../../../App";
import useGetOurStory from "../../../../hooks/use-get-our-story";
import classNames from "classnames";
import Modal from "../../../../components/common/Modal";
import useDeleteOurStory from "../../../../hooks/use-delete-our-story";
import { toast } from "react-toastify";
import useUpdateOurStoryOrderAndStatus from "../../../../hooks/use-update-our-story-order-status";
import useUpdateOurStoryStatus from "../../../../hooks/use-update-our-story-status";
import { useGetUserPermission } from "../../../../context/AuthStaffUserContext";

type IFormData = {
  videos: IVideos[];
};

// OLD: const [pageSize, setPageSize] = useState<number>(10); — was inside component
const PAGE_SIZE = 12;

const OurStory = ({ data, loading, onSave }: ICategoryComponentProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  // OLD: const [pageSize, setPageSize] = useState<number>(10);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [maxVideoDuration, setMaxVideoDuration] = useState<number>(0);
  const [maxImages, setMaxImages] = useState<number>(0);
  const [previewItem, setPreviewItem] = useState<IVideos | null>(null);


  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const openDeleteModal = () => setDeleteModal(true);
  const closeDeleteModal = () => setDeleteModal(false);
  // const [InitialFormData, setInitialFormData] = useState<IFormData>({videos:[]});

  const methods = useForm<IFormData>({ defaultValues: { videos: [] } });
  const { handleSubmit } = methods;
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const {
    fields: videoFields,
    // append: appendAlarmField,
    remove: removeVideoField,
    replace: replaceVideoFields,
  } = useFieldArray({
    name: "videos",
    control: methods.control,
    keyName: "customId",
  });

  const {
    data: eligibilityCriteriaData,
    isLoading: eligibilityCriteriaLoading,
  } = useGetEligibilityCriteriaQuery();
  const { data: ourStoryData, isPending: getOurStoryLoading } =
    useGetOurStory();
  const { mutate: deleteOurStory, isPending: deleteLoader } =
    useDeleteOurStory();
  const { mutate: updateOrderStatus } = useUpdateOurStoryOrderAndStatus();
  const { mutate: updateOrderActiveStatus } = useUpdateOurStoryStatus();

  // const eligibilityOptions =
  //   eligibilityCriteriaData?.result?.data
  //     .sort((b, a) => b.viewRank - a.viewRank)
  //     .flatMap((x) => x.options || []) || [];

  useEffect(() => {
    if (ourStoryData?.result?.data?.items) {
      const sortedVideos = [...ourStoryData.result.data.items].sort(
        (a, b) => a?.orderKey - b?.orderKey
      );

      replaceVideoFields(sortedVideos);
      setVideoData({
        categoryName,
        items: sortedVideos,
      });
    }
    if (ourStoryData?.result?.data?.maxVideoDuration) {
      setMaxVideoDuration(ourStoryData?.result?.data?.maxVideoDuration);
    }
    if (ourStoryData?.result?.data?.maxImagesForHomeTv) {
      setMaxImages(ourStoryData?.result?.data?.maxImagesForHomeTv);
    }
  }, [ourStoryData, replaceVideoFields]);

  const categoryName = data?.categoryName || "";

  const [videoData, setVideoData] = useState(() => ({
    categoryName,
    items:
      [...(videoFields as IVideos[])]?.sort(
        (a, b) => a.orderKey - b.orderKey
      ) ?? [], // Use subData directly or default to an empty array
  }));

  useEffect(() => {
    // Sort and update videoData.items whenever videoFields changes
    const sorted = [...videoFields].sort((a, b) => a.orderKey - b.orderKey);
    setVideoData((prev) => ({
      ...prev,
      items: sorted,
    }));
  }, [videoFields]);

  const getTableDataIndex = (id: string) => {
    return videoFields.findIndex((item) => item._id === id);
  };

  const onDropComplete = () => {
    const updatedItems = [...videoData.items].map((item, index) => ({
      ...item,
      orderKey: index + 1,
    }));
    setVideoData((prev) => ({
      ...prev,
      items: updatedItems.sort((a, b) => a?.orderKey - b?.orderKey),
    }));
    const updateData = updatedItems.map((ele) => ({
      id: ele._id,
      orderKey: ele.orderKey,
      isSelected: ele.isSelected,
    }));
    updateOrderStatus(updateData, {
      onSuccess: (_res) => {
        // toast.success(res?.result?.message);
      },
      onError: (error) => {
        const message =
          error.response?.data.result.message || "An unexpected error occurred";
        console.log({ message, error });

        // toast.error(message);
      },
    });
  };

  const onSubmit = (submitData: IFormData) => {
    const orderKeyMap = new Map(
      videoData.items.map((item, index) => [
        item._id,
        item.orderKey || index + 1,
      ])
    );

    const mergedData = submitData.videos
      .sort((a, b) => a?.orderKey - b?.orderKey)
      .map((item) => ({
        ...item,
        orderKey: orderKeyMap.get(item._id) ?? item.orderKey,
      }));
    onSave({
      categoryName: data?.categoryName,
      data: {
        ...data,
        videos: mergedData,
      },
    });
  };

  const handleDelete = (id: string) => {
    deleteOurStory(
      { id },
      {
        onSuccess: (res) => {
          removeVideoField(
            videoFields.findIndex((ele) => ele?._id === selectedId)
          );
          toast.success(res?.result?.message);
          closeDeleteModal();
        },
        onError: (error) => {
          closeDeleteModal();
          const message =
            error.response?.data.result.message ||
            "An unexpected error occurred";
          toast.error(message);
        },
      }
    );
  };

  const handleActiveStatus = (
    id: string,
    currentStatus: boolean | undefined,
    eligibilityCriteriaId: string | undefined,
    valueId: string | string[] | undefined
  ) => {
    updateOrderActiveStatus(
      { id: id, isSelected: currentStatus, eligibilityCriteriaId, valueId },
      {
        onSuccess: (res) => {
          methods.setValue(
            `videos.${getTableDataIndex(id)}.isSelected`,
            currentStatus
          );
          toast.success(res?.result?.message);
          closeDeleteModal();
        },
        onError: (error) => {
          closeDeleteModal();
          const message =
            error.response?.data.result?.message ||
            "An unexpected error occurred";
          toast.error(message);
        },
      }
    );
  };

  const { write: isEditPermission } = useGetUserPermission("tv-app");

  // OLD tableColumns (kept for reference — remove if card grid is final):
  // const tableColumns: ITableColumn<IVideos>[] = setDragOnlyInStaging<ITableColumn<IVideos>>([
  //   {
  //     name: "",
  //     cell: (Row, index) => (
  //       <DraggableRow index={index} moveRow={moveRow} onDropComplete={onDropComplete}>
  //         <DragSvg height={24} width={24} className="h-6 w-6 cursor-grab flex-none" />
  //       </DraggableRow>
  //     ),
  //     sortable: true, width: "10%",
  //   },
  //   { name: "Image", cell: (Row) => <div><img src={Row.thumbnail} width={64} height={39} alt="thumbnail" /></div>, sortable: true, width: "10%" },
  //   { name: "Name", cell: (Row) => <span style={{ fontWeight: 400, fontSize: "14px" }}>{Row.name || ""}</span>, sortable: true, width: "20%" },
  //   { name: "Media Type", cell: (Row) => <span>{Row?.images?.length > 0 ? "Image" : "Video"}</span>, sortable: true, width: "10%" },
  //   { name: "Guest Type", cell: (Row) => <span style={{ fontWeight: 400, fontSize: "14px" }}>{eligibilityCriteriaData?.result?.data.find((ele) => ele._id === Row.eligibilityCriteria)?.name || "-"}</span>, sortable: true, width: "25%" },
  //   { name: "Enable/Disable", cell: (Row) => <Switch name={`videos.${getTableDataIndex(Row._id)}.isSelected`} checked={videoFields.find((ele) => ele._id === Row._id)?.isSelected} onCheck={(isChecked) => { handleActiveStatus(Row._id, !isChecked, Row.eligibilityCriteria, Row.value); }} disabled={!isEditPermission} />, sortable: true, center: true, width: "15%" },
  //   { name: "Action", cell: (Row) => (<div className="flex items-center gap-2"><div onClick={() => { setSelectedId(Row._id); }}><EditOurStory disabled={!isEditPermission} data={videoData.items.find((ele) => ele._id === selectedId) || null} isEditVideo={!!selectedId} onClose={async () => { await queryClient.refetchQueries({ queryKey: ["hotel-our-story"] }); }} /></div><div onClick={getOurStoryLoading ? undefined : () => { if (!isEditPermission) return; setSelectedId(Row._id); openDeleteModal(); }} className={classNames("h-8 w-8 rounded-full bg-[#FFF1F2] flex items-center justify-center hover:bg-[#FFE4E6] transition-colors", getOurStoryLoading || !isEditPermission ? "opacity-50" : "cursor-pointer")}><TrashSvg color="#E52727" /></div></div>), sortable: true, center: true, width: "10%" },
  // ]);

  const moveRow = (fromIndex: number, toIndex: number) => {
    if (!videoData?.items) return;

    // OLD: const globalFromIndex = (currentPage - 1) * pageSize + fromIndex;
    // OLD: const globalToIndex = (currentPage - 1) * pageSize + toIndex;
    const globalFromIndex = (currentPage - 1) * PAGE_SIZE + fromIndex;
    const globalToIndex = (currentPage - 1) * PAGE_SIZE + toIndex;

    const updatedData = [...videoData.items];
    const [movedItem] = updatedData.splice(globalFromIndex, 1);
    updatedData.splice(globalToIndex, 0, movedItem);

    const reOrdered = updatedData.map((item, index) => ({
      ...item,
      orderKey: index + 1,
    }));

    setVideoData({
      ...videoData,
      items: reOrdered,
    });
  };


  const sortedItems = [...videoData.items].sort((a, b) => a?.orderKey - b?.orderKey);
  const totalItems = sortedItems.length;
  const totalPages = Math.ceil(totalItems / PAGE_SIZE);
  const paginatedItems = sortedItems.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );
  const isLoading = eligibilityCriteriaLoading || getOurStoryLoading;

  return (
    <FormProvider {...methods}>
      <div>
        <h3 className="text-[22px] font-normal text-[#111827]">Our Story</h3>
        {/* <div className="">
          <Switch name="showAlarm" label="Our Story (Hide/Show) " disabled={!isEditPermission}/>
        </div> */}
        <div className="flex items-center justify-end w-full">
          <Button
            variant="primary"
            className="w-21"
            onClick={openModal}
            disabled={!isEditPermission}
          >
            Add
          </Button>
        </div>

        {/* OLD DataTable (kept for reference — remove if card grid is final):
        <DndProvider backend={HTML5Backend}>
          <DataTable
            className="border-t mt-6"
            data={videoData?.items.sort((a, b) => a?.orderKey - b?.orderKey) || []}
            columns={tableColumns}
            persistTableHead
            pagination={videoFields.length > 10}
            customStyles={{
              headRow: { style: { paddingLeft: "36px" } },
              rows: { style: { paddingLeft: "36px" } },
            }}
            progressPending={eligibilityCriteriaLoading || getOurStoryLoading}
            progressComponent={<div className="mt-10"><Spinner /></div>}
            onChangePage={(page) => setCurrentPage(page)}
            onChangeRowsPerPage={(perPage) => setPageSize(perPage)}
          />
        </DndProvider>
        */}

  
        {isLoading ? (
          <div className="mt-10 flex justify-center">
            <Spinner />
          </div>
        ) : (
          <DndProvider backend={HTML5Backend}>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6 gap-3 mt-6">
              {paginatedItems.map((item, index) => {
                const guestType =
                  eligibilityCriteriaData?.result?.data.find(
                    (ele) => ele._id === item.eligibilityCriteria
                  )?.name || "-";
                const mediaType = item?.images?.length > 0 ? "Image" : "Video";
                const isActive = videoFields.find((ele) => ele._id === item._id)?.isSelected;

                return (
                  <DraggableRow
                    key={item._id}
                    index={index}
                    moveRow={moveRow}
                    onDropComplete={onDropComplete}
                    custumClassName="w-full h-full"
                  >
                    <div className="bg-white rounded-xl border border-[#E5E7EB] shadow-sm overflow-hidden flex flex-col w-full h-full">
                      {/* Image preview */}
                      <div
                        className="relative w-full aspect-video bg-[#F5F5F5] flex-shrink-0 overflow-hidden cursor-pointer group"
                        onClick={(e) => {
                          e.stopPropagation();
                          setPreviewItem(item);
                        }}
                      >
                        {item.thumbnail ? (
                          <>
                            <img
                              src={item.thumbnail}
                              aria-hidden="true"
                              className="absolute inset-0 w-full h-full object-cover scale-110 blur-xl opacity-70"
                            />
                            <img
                              src={item.thumbnail}
                              alt={item.name}
                              className="relative z-10 w-full h-full object-contain transition-transform duration-200 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/0 group-hover:bg-black/20 transition-colors duration-200">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 drop-shadow-lg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0zM11 8v6m-3-3h6" />
                              </svg>
                            </div>
                          </>
                        ) : (
                          <div className="w-full h-full flex items-center justify-center text-[#9CA3AF] text-sm">
                            No Preview
                          </div>
                        )}
                        {/*
                        <div className="absolute top-2 left-2 bg-white/80 backdrop-blur-sm rounded-lg p-1.5 cursor-grab shadow-sm">
                          <DragSvg height={14} width={14} className="text-[#6B7280]" />
                        </div>
                        */}
                        <div className="absolute top-2 right-2 bg-black/60 text-white text-[10px] font-medium px-2 py-0.5 rounded-md">
                          {mediaType}
                        </div>
                      </div>

                      {/* Card body */}
                      <div className="p-2 flex flex-col gap-1.5 flex-1">
                        <h4
                          className="text-[13px] font-semibold text-[#111827] truncate leading-tight"
                          title={item.name}
                        >
                          {item.name || "—"}
                        </h4>

                        <div className="text-[12px] text-[#6B7280] space-y-0.5">
                          <div className="flex items-center gap-1">
                            <span className="text-[#374151] font-medium">Guest Type:</span>
                            <span className="truncate">{guestType}</span>
                          </div>
                        </div>

                        {/* Status + Actions row */}
                        <div className="flex items-center justify-between pt-2 mt-auto border-t border-[#E5E7EB]">
                          <div className="flex items-center gap-1.5">
                            <Switch
                              name={`videos.${getTableDataIndex(item._id)}.isSelected`}
                              checked={isActive}
                              onCheck={(isChecked) => {
                                handleActiveStatus(
                                  item._id,
                                  !isChecked,
                                  item.eligibilityCriteria,
                                  item.value
                                );
                              }}
                              disabled={!isEditPermission}
                            />
                            {/* 
                            <span
                              className={classNames(
                                "text-[11px] font-medium",
                                isActive ? "text-secondary" : "text-[#9CA3AF]"
                              )}
                            >
                              {isActive ? "Enabled" : "Disabled"}
                            </span>
                            */}
                          </div>
                          <div className="flex items-center gap-1.5">
                            <div onClick={() => setSelectedId(item._id)}>
                              <EditOurStory
                                disabled={!isEditPermission}
                                data={
                                  videoData.items.find((ele) => ele._id === selectedId) || null
                                }
                                isEditVideo={!!selectedId}
                                onClose={async () => {
                                  await queryClient.refetchQueries({
                                    queryKey: ["hotel-our-story"],
                                  });
                                }}
                              />
                            </div>
                            <div
                              onClick={
                                getOurStoryLoading
                                  ? undefined
                                  : () => {
                                      if (!isEditPermission) return;
                                      setSelectedId(item._id);
                                      openDeleteModal();
                                    }
                              }
                              className={classNames(
                                "h-8 w-8 rounded-full bg-[#FFF1F2] flex items-center justify-center hover:bg-[#FFE4E6] transition-colors",
                                getOurStoryLoading || !isEditPermission
                                  ? "opacity-50"
                                  : "cursor-pointer"
                              )}
                            >
                              <TrashSvg color="#E52727" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </DraggableRow>
                );
              })}
            </div>

            {/* Pagination */}
            {totalItems > PAGE_SIZE && (
              <div className="flex items-center justify-end gap-2 mt-6">
                <span className="text-sm text-[#6B7280]">
                  {(currentPage - 1) * PAGE_SIZE + 1}–
                  {Math.min(currentPage * PAGE_SIZE, totalItems)} of {totalItems}
                </span>
                <button
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  className="h-8 w-8 border border-[#E5E7EB] flex items-center justify-center text-[#374151] disabled:opacity-40 hover:bg-[#F5F5F5] transition-colors text-base leading-none"
                >
                  ‹
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter(
                    (p) =>
                      p === 1 ||
                      p === totalPages ||
                      Math.abs(p - currentPage) <= 1
                  )
                  .reduce<(number | "…")[]>((acc, p, i, arr) => {
                    if (i > 0 && p - (arr[i - 1] as number) > 1) acc.push("…");
                    acc.push(p);
                    return acc;
                  }, [])
                  .map((p, i) =>
                    p === "…" ? (
                      <span key={`ellipsis-${i}`} className="px-1 text-[#9CA3AF] text-sm">
                        …
                      </span>
                    ) : (
                      <button
                        key={p}
                        onClick={() => setCurrentPage(p as number)}
                        className={classNames(
                          "h-8 w-8 border text-sm transition-colors",
                          currentPage === p
                            ? "bg-secondary text-white border-secondary"
                            : "border-[#E5E7EB] text-[#374151] hover:bg-[#F5F5F5]"
                        )}
                      >
                        {p}
                      </button>
                    )
                  )}
                <button
                  onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                  className="h-8 w-8 border border-[#E5E7EB] flex items-center justify-center text-[#374151] disabled:opacity-40 hover:bg-[#F5F5F5] transition-colors text-base leading-none"
                >
                  ›
                </button>
              </div>
            )}
          </DndProvider>
        )}

        {/* <DiscardSaveButtons
          onDiscard={() => {}}
          onSave={handleSubmit(onSubmit)}
          loading={loading}
          className="mt-10"
        /> */}
        <div
          className={classNames("flex items-center justify-end gap-[18px]", "")}
        >
          <Button
            className={classNames("w-25.5", "mt-10")}
            variant="primary"
            loading={loading}
            disabled={loading || !isEditPermission}
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>
        </div>

        <OurStoryPreview
          item={previewItem}
          onClose={() => setPreviewItem(null)}
          getGuestTypeName={(id) =>
            eligibilityCriteriaData?.result?.data.find((ele) => ele._id === id)?.name ?? "—"
          }
        />

        <Modal
          isOpen={deleteModal}
          closeModal={() => {
            closeDeleteModal();
            closeModal();
          }}
          title="Are you sure you want to delete this?"
          className="w-144.75"
        >
          <div className="flex items-center justify-end gap-[18px] mt-9">
            <Button className="w-25.5" onClick={closeDeleteModal}>
              Cancel
            </Button>
            <Button
              onClick={() => {
                handleDelete(selectedId!);
              }}
              loading={deleteLoader}
              disabled={deleteLoader}
              className="w-25.5"
              variant="primary"
            >
              Delete
            </Button>
          </div>
        </Modal>

        <AddOurStortyModal
          isOpen={isModalOpen}
          closeModal={closeModal}
          categoryName={data.categoryName}
          maxVideoDuration={maxVideoDuration}
          maxImages={maxImages}
        />
      </div>
    </FormProvider>
  );
};

export default OurStory;
